import { Routes } from '@angular/router';

import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
// import { authGuard } from './guards/auth.guard';
import { viewGuard } from './guards/view.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',

    loadChildren: () => import('./templates/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'main',
    canActivate: [viewGuard],
    loadChildren: () => import('./templates/views/views.routes').then((m) => m.viewsRoutes),
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
];
